import api from './api/axiosConfig';

const societyReviewService = {
  // Get reviews for a specific society
  getSocietyReviews: async (societyId, params = {}) => {
    try {
      const response = await api.get(`/societies/${societyId}/reviews/`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching society reviews:', error);
      throw error;
    }
  },

  // Create a new review for a society
  createSocietyReview: async (societyId, reviewData) => {
    try {
      const response = await api.post(`/societies/${societyId}/reviews/`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Error creating society review:', error);
      throw error;
    }
  },

  // Update an existing review
  updateSocietyReview: async (societyId, reviewId, reviewData) => {
    try {
      const response = await api.put(`/societies/${societyId}/reviews/${reviewId}/`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Error updating society review:', error);
      throw error;
    }
  },

  // Delete a review
  deleteSocietyReview: async (societyId, reviewId) => {
    try {
      const response = await api.delete(`/societies/${societyId}/reviews/${reviewId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting society review:', error);
      throw error;
    }
  },

  // Get review statistics for a society
  getSocietyReviewStats: async (societyId) => {
    try {
      const response = await api.get(`/societies/${societyId}/reviews/stats/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching society review stats:', error);
      throw error;
    }
  },

  // Get a specific review
  getSocietyReview: async (societyId, reviewId) => {
    try {
      const response = await api.get(`/societies/${societyId}/reviews/${reviewId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching society review:', error);
      throw error;
    }
  }
};

export default societyReviewService;
